const fields = [
  {
    dataIndex: 'id',
    key: 'id',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'title',
    key: 'title',
    title: '产品名称',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'financialTypeStr',
    key: 'financialTypeStr',
    width: 110,
    title: '产品类型'
  },
  {
    dataIndex: 'statusStr',
    key: 'status',
    width: 110,
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    dataIndex: 'publishTime',
    key: 'publishTime',
    title: '发布日期',
    width: 120
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建日期',
    width: 120
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '产品名称',
    component: 'AInput',
    placeholder: '请输入产品名称',
    prop: 'title',
    allowClear: true
  },
  {
    span: 8,
    label: '产品类型',
    component: 'ASelect',
    placeholder: '请输入产品类型',
    prop: 'financialType',
    allowClear: true,
    list: [
      { label: '金融机构', value: 1 },
      { label: '商业银行', value: 2 },
      { label: '担保公司', value: 3 },
      { label: '保险公司', value: 4 }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      { name: '删除', cb: 'delete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
